// Mensagem direto no aplicativo do WhatsApp do computador (Pedro, 23/10/2026; Pajú Burguer: cada «Enviar e Alterar
// Status» abria uma aba do api.whatsapp.com que ficava aberta). O link whatsapp:// abre o aplicativo sem aba, mas sem o
// aplicativo instalado não abre nada, então é escolha de cada computador da loja (um tem o aplicativo, outro não), com
// saída pelo navegador. Todas as lojas, no Windows e no Mac (Pedro, 23/10: sem Mac para testar, fica até alguém reclamar).
// Vale para TODO botão do painel que abre o WhatsApp (Pedro, 23/10: «é para fazer em todos»): eles passam pelo
// `abreWhatsApp` (lib/abreWhatsApp.tsx). A caixinha fica nos modais de status e de frete.
const CHAVE = "vnz:whatsapp-no-app";
const ESPERA_MS = 2500;

/** Windows ou Mac, que têm o aplicativo do WhatsApp. No celular, o link de hoje já abre o aplicativo. */
export function computadorComAppDoWhatsApp(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  if (/Android|iPhone|iPad|Mobi/i.test(ua)) return false;
  // O iPad se apresenta como Mac; a tela de toque denuncia.
  if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return false;
  return /Windows NT|Macintosh/.test(ua);
}

export function usaOAppNesteComputador(): boolean {
  try {
    return localStorage.getItem(CHAVE) === "1";
  } catch {
    return false;
  }
}

export function guardaUsoDoApp(usa: boolean) {
  try {
    if (usa) localStorage.setItem(CHAVE, "1");
    else localStorage.removeItem(CHAVE);
  } catch {}
}

/** Este computador escolheu o aplicativo (e é um computador que o tem). */
export const vaiPeloAppDoWhatsApp = () => computadorComAppDoWhatsApp() && usaOAppNesteComputador();

/** O link do aplicativo com o mesmo destinatário e o mesmo texto do link da web (api.whatsapp.com/send?…). Outro
 *  formato de link não tem equivalente: null, e fica a aba. */
export function linkDoAppPeloDaWeb(linkWeb: string): string | null {
  const m = /^https:\/\/api\.whatsapp\.com\/send\?(.*)$/.exec(linkWeb);
  return m ? `whatsapp://send?${m[1]}` : null;
}

/** Abre no aplicativo, sem aba. Se em 2,5 s o navegador não perde o foco (o aplicativo não veio para a frente),
 *  chama `naoAbriu`, que oferece o caminho pelo navegador. */
export function abreNoAppDoWhatsApp(linkDoApp: string, naoAbriu: () => void) {
  let saiu = false;
  const marca = () => {
    saiu = true;
  };
  window.addEventListener("blur", marca);
  document.addEventListener("visibilitychange", marca);
  // Clique num link (e não location.href): sem o aplicativo, o Firefox mostraria página de erro no lugar do painel.
  const a = document.createElement("a");
  a.href = linkDoApp;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => {
    window.removeEventListener("blur", marca);
    document.removeEventListener("visibilitychange", marca);
    if (!saiu) naoAbriu();
  }, ESPERA_MS);
}
